export default __webpack_public_path__ + "assets/MyAccess_1.png";